var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8283_104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5601 17.2643C34.1921 16.5763 31.7601 16.2083 29.3121 16.1603C28.2721 16.1443 27.6641 17.3123 28.2401 18.2083C29.3441 19.9523 29.9841 22.0163 29.9841 24.1923V27.8723C29.9841 28.0803 29.9841 28.2883 29.9521 28.4963C29.8561 29.2963 30.4321 29.9843 31.2321 29.9843H39.6161C40.7841 29.9843 41.7281 29.0243 41.7281 27.8563V24.1763C41.7281 20.9763 39.6321 18.1283 36.5601 17.2483",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.88 17.2485C15.76 15.7765 10.32 15.7765 5.2 17.2485C2.128 18.1285 0 20.9605 0 24.1765V27.8565C0 29.0245 0.944 29.9845 2.112 29.9845H23.968C25.136 29.9845 26.08 29.0245 26.08 27.8565V24.1765C26.08 20.9605 23.952 18.1285 20.88 17.2485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6882 13.12C32.2882 13.12 35.2162 10.176 35.2162 6.56C35.2162 2.944 32.3042 0 28.6882 0C25.0722 0 22.1602 2.944 22.1602 6.56C22.1602 10.176 25.0722 13.12 28.6882 13.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0397 13.12C16.6397 13.12 19.5677 10.176 19.5677 6.56C19.5677 2.944 16.6397 0 13.0397 0C9.43972 0 6.51172 2.944 6.51172 6.56C6.51172 10.176 9.42372 13.12 13.0397 13.12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8283_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.728,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group_icon.19e53f7b4b4b74c79a11da2f5c20b46c.svg";
export { ForwardRef as ReactComponent };